import { Box, Card, CardContent, Typography } from '@mui/material';
import { ReactNode } from 'react';

const defaultCardSx = {
  boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.08)',
  border: '1px solid #EDF2F7',
  borderRadius: '8px',
};

interface InfoCardProps {
  title: string;
  icon?: ReactNode;
  children: ReactNode;
  cardSx?: object;
}

const InfoCard = ({ title, icon, children, cardSx = defaultCardSx }: InfoCardProps) => (
  <Card sx={cardSx}>
    <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
      {/* Card Header */}
      <Box
        display="flex"
        alignItems="center"
        sx={{ gap: 1 }}
        px={2.5}
        pt={2}
        pb={1.5}
        borderBottom="1px solid #EDF2F7"
      >
        {icon && <Box sx={{ display: 'flex', alignItems: 'center' }}>{icon}</Box>}
        <Typography variant="h6" style={{ fontWeight: 600 }}>
          {title}
        </Typography>
      </Box>

      {/* Card Content */}
      <Box px={2.5} py={2}>
        {children}
      </Box>
    </CardContent>
  </Card>
);

export default InfoCard;
